import { useState } from "react";
import { useSiteLink } from "../link";

// The site's shared header and footer. Internal links resolve through the
// SiteLink context, so on the public website they navigate via react-router and
// in the admin preview they open the matching page's editor. External links
// stay plain anchors. Markup mirrors the original apps/website Layout exactly so
// the chrome looks identical on the live site.

export function SiteHeader() {
  const Link = useSiteLink();
  const [open, setOpen] = useState(false);
  return (
    <header className="site-head">
      <div className="wrap">
        <Link className="brand" to="/">
          <img src="/img/logo-dark.png" alt="Quintara" width={520} height={134} />
        </Link>
        <button
          className="menu-toggle"
          type="button"
          aria-expanded={open}
          aria-controls="site-nav"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? "Close" : "Menu"}
        </button>
        <nav className={open ? "nav open" : "nav"} id="site-nav" aria-label="Main" onClick={() => setOpen(false)}>
          <Link to="/solutions">Solutions</Link>
          <Link to="/platform">Platform</Link>
          <Link to="/company">Company</Link>
          <Link className="btn btn-app" to="/contact">
            <span className="grad-text">Talk to us</span>
          </Link>
          {/* External link to the portal app — opens in a new tab so it never
              navigates the admin preview iframe (or the marketing SPA) away. */}
          <a className="btn btn-primary" href="https://app.quintaratech.com/" target="_blank" rel="noopener">
            Go to app
          </a>
        </nav>
      </div>
    </header>
  );
}

export function SiteFooter() {
  const Link = useSiteLink();
  const year = new Date().getFullYear();
  return (
    <footer className="site-foot">
      <div className="wrap foot-grid">
        <div className="foot-entity">
          <img src="/img/logo-dark.png" alt="Quintara" width={520} height={134} />
          <p>Business messaging on WhatsApp for enterprises, governments, agencies, mobile operators and SMBs.</p>
          <p>
            <b style={{ color: "var(--text)", fontWeight: 600 }}>Quintara Advertising Services L.L.C</b>
            <br />
            Dubai, United Arab Emirates
            <br />
          </p>
        </div>
        <div>
          <h4>Company</h4>
          <ul>
            <li>
              <Link to="/company">About Quintara</Link>
            </li>
            <li>
              <Link to="/company#consortium">The consortium</Link>
            </li>
            <li>
              <Link to="/careers">Careers</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>
        <div>
          <h4>Product</h4>
          <ul>
            <li>
              <Link to="/solutions">Solutions</Link>
            </li>
            <li>
              <Link to="/platform">Platform</Link>
            </li>
            <li>
              <Link to="/platform#quality">Quality and policy</Link>
            </li>
            <li>
              <Link to="/platform#security">Security</Link>
            </li>
          </ul>
        </div>
        <div>
          <h4>Legal</h4>
          <ul>
            <li>
              <Link to="/privacy">Privacy policy</Link>
            </li>
            <li>
              <Link to="/terms">Terms of use</Link>
            </li>
            <li>
              <Link to="/government-data-request-policy">Government Data Request Policy</Link>
            </li>
            <li>
              <a href="https://numbase.com" target="_blank" rel="noopener">
                Numbase Group ↗
              </a>
            </li>
            <li>
              <a href="https://jgroup-me.com" target="_blank" rel="noopener">
                JGroup ↗
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="wrap foot-legal">
        <span>© {year} Quintara Advertising Services L.L.C. All rights reserved.</span>
        <span>WhatsApp and Meta are trademarks of Meta Platforms, Inc. Quintara is an independent company.</span>
      </div>
    </footer>
  );
}
